function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M36.985 0H7.963C7.155 0 6.5.655 6.5 1.926V55c0 .345.655 1 1.463 1h40.074c.808 0 1.463-.655 1.463-1V12.978c0-.696-.093-.92-.257-1.085L37.607.257A.884.884 0 0036.985 0z",
  fill: "#e9e9e0"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#d9d7ca",
  d: "M37.5.151V12h11.849z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M48.037 56H7.963A1.463 1.463 0 016.5 54.537V39h43v15.537c0 .808-.655 1.463-1.463 1.463z",
  fill: "#ec6630"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.455 42.924V53h-1.641v-4.539h-4.361V53H9.785V42.924h1.668v4.416h4.361v-4.416h1.641zM27.107 42.924v1.121H24.1V53h-1.654v-8.955h-3.008v-1.121h7.669zM36.705 42.924h1.668V53h-1.668v-6.932l-2.256 5.605H33l-2.27-5.605V53h-1.668V42.924h1.668l2.994 6.891 2.981-6.891zM42.57 42.924v8.832h4.635V53h-6.303V42.924h1.668z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  fill: "#ec6630"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.207 16.293a.999.999 0 00-1.414 0l-6 6a.999.999 0 000 1.414l6 6a.997.997 0 001.414 0 .999.999 0 000-1.414L17.914 23l5.293-5.293a.999.999 0 000-1.414zM41.207 22.293l-6-6a.999.999 0 10-1.414 1.414L39.086 23l-5.293 5.293a.999.999 0 101.414 1.414l6-6a.999.999 0 000-1.414z"
}));

var SvgHtml = function SvgHtml(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default SvgHtml;